import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import Steps, { Step } from 'meinian-package/src/baseComponent/steps'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import request from 'meinian-package/src/utils/request'
import { hasRelateUrl } from '../../../../../../component/imageDetail/related'
import { formatTime } from '../../../../../../component/util'
import styles from './index.module.less'

export default forwardRef(({ currentImage }:any, ref) => {
  const MAX_DYNAMICS_COUNT = 4
  const [isFold, setIsFold] = useState(true)
  const [sampleShow, setSampleShow] = useState([])

  useImperativeHandle(ref, () => {
    return {
      onInit: fetchSampleShow
    }
  })

  const fetchSampleShow = async () => {
    if (currentImage.id) {
      const res:any = await request.get('/zhikuan/mn/dynamic/query-operation-dynamic-info', { params: { targetType: 2, targetId: currentImage.id } })
      setSampleShow(res)
    }
  }

  useEffect(() => {
    fetchSampleShow()
  }, [currentImage.id])

  return <div className={classNames(styles.infoBlock, 'mt32')}>
    <div className={styles.titleLine}>
      <div className={styles.point} /><div className={styles.mainTitle}>
        样衣动态
        {sampleShow.length > 4 ? <a className={classNames(styles['fold-dynamic'], 'fill-white-bg')} onClick={() => setIsFold(pre => !pre)}>{isFold ? '展开' : '收起'}<Icon type="m-Vxing_xia" style={{ transform: isFold ? undefined : 'rotate(180deg)', transition: 'all 0.3s' }} /></a> : null}
      </div>
    </div>
    <div className={styles.infoBlockContext}>
      <Steps className={styles.infoViewModuleDynamics}>
        {sampleShow?.filter((m, index) => (isFold ? index < MAX_DYNAMICS_COUNT : true)).map((m, i) => <Step
          active={i === 0}
          title={<div
            className={classNames('dynamic-item', i === 0 ? 'active' : '')}
          >
            <div className="dynamic-status-desc">
              <span style={{ marginRight: '8px' }}>{m.operationDesc}</span>
              {hasRelateUrl(m) && <a className="dynamic-link link" style={{ color: 'var(--m-link-normal)' }} href={hasRelateUrl(m)} target="_blank" rel="noreferrer">相关款式</a>}
            </div>
            <div className="meinian-space" />
            <div className="dynamic-user text-overflow">{m.operationName}</div>
            <div className="dynamic-time">{formatTime(m.operationTime)}</div>
          </div>}
        />)}
      </Steps>
    </div>
  </div>
})
